<template>
    <div v-if="memberships.length" class="datatable-theme">
        <easy-data-table
            v-if="memberships.length"
            class="table"
            :headers="headers"
            :items="memberships"
            :hide-footer="memberships.length < 10"
            :rows-per-page="10"
            :rows-items="[10, 25, 50]"
            buttons-pagination
        >
            <template #item-membership.subscription_plan.title="membership">
                <span
                    class="rounded bg-primary-500 py-1 px-2 text-[14px] font-medium text-white"
                    >{{ membership.subscription_plan.title }}</span
                >
                membership added
            </template>
            <template #item-membership.updated_at="membership">
                {{
                    dayjs(membership.updated_at).format(
                        $page.props.date_formats.full_nice
                    )
                }}
            </template>
        </easy-data-table>
    </div>
</template>

<script>
export default {
    name: "group-student-membership-history-table",
    components: {},
    props: {
        memberships: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            headers: [
                {
                    text: "Membership Length",
                    value: "membership.subscription_plan.title",
                },
                {
                    text: "Applied At",
                    value: "membership.updated_at",
                },
            ],
        };
    },
};
</script>
